module.exports = __webpack_public_path__ + "img/animation-video-alexgrigg-poster.3cc1f31.jpg";